export default "__VITE_ASSET__CqH$_0ge__"